import {action, makeAutoObservable, observable, runInAction} from "mobx";
import {inject, injectable} from "inversify";
import type {IJSONProvider, IHelpPages} from "data/providers/json/json.provider";
import {Bindings} from "data/constants/bindings";

export interface IStaticStore {
	get getIsLoading(): boolean;

	get listHelpPages(): IHelpPages;

	fetchHelpPages(): Promise<void>;
}

@injectable()
export class StaticStore implements IStaticStore {
	@observable private _isLoading: boolean = false;
	@observable private _listHelpPages: IHelpPages = {
		guidelines: [],
		terms: [],
		privacy: [],
		how_to_play: [],
		prizes: [],
		faq: [],
	};

	constructor(@inject(Bindings.JSONProvider) private _jsonProvider: IJSONProvider) {
		makeAutoObservable(this);
	}

	get getIsLoading(): boolean {
		return this._isLoading;
	}

	get listHelpPages() {
		return this._listHelpPages;
	}

	@action
	async fetchHelpPages() {
		if (this._isLoading) {
			return;
		}

		try {
			this.changeLoadingState(true);
			const responseHelp = await this._jsonProvider.help_pages();
			const responseFaq = await this._jsonProvider.faq_page();

			runInAction(() => {
				this._listHelpPages = {
					...responseHelp.data,
					faq: responseFaq.data,
				};
			});
		} finally {
			this.changeLoadingState(false);
		}
	}

	@action
	private changeLoadingState(value: boolean): void {
		runInAction(() => {
			this._isLoading = value;
		});
	}
}
